<script>
	import { createEventDispatcher, getContext, onMount } from 'svelte';

	import { keyToken, keyUser, ROLE_VIEWER } from '../../globals.js';
	import { formatCurrency, formatDateISO } from '../formatting.js';

	const dispatch = createEventDispatcher();

	const { getToken } = getContext(keyToken);
	const token = getToken();
	const { getUser } = getContext(keyUser);
	const user = getUser();

	let stock = {};
	let isin;
	let title = '';
	let buySell = 'buy';
	let date;
	let quantity;
	let price;
	let fee;
	let tax;
	let comment;

	async function loadAssetDetail() {
		if (!token) {
			console.warn('Not logged in!');
			return;
		}

		await fetch('https://ostium.ch/api/borsalino/get_asset.php', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
				'Authorization': 'JWT ' + encodeURIComponent(token)
			},
			body: JSON.stringify({ isin: isin })
		}).then(result => {
			if (result.ok) {
				console.log('Loaded asset detail successfully.');
				result.json().then(data => {
					console.log('Asset detail:', data);
					stock = data;
					stock.date = stock.value_date != null ? new Date(data.value_date) : null
					title = data.name;
					date = formatDateISO(new Date());
					price = stock.last / stock.factor;
				});
			} else {
				console.warn('Could not load asset detail of ISIN ' + isin, result.statusText);
				result.text().then(data => {
					console.log('Error:', data);
					dispatch('message', {
						type: 'error',
						text: data.replace(/<.*>/g, '')
					});
				});
			}
		});
	}

	async function savePortfolioDetail() {
		let detail = {
			isin: isin,
			value_date: date,
			dividend: buySell === 'dividend',
			quantity: quantity != null ? (buySell === 'sell' ? -quantity : quantity) : null,
			price: price != null ? price : null,
			fee: fee != null ? fee : null,
			tax: tax != null ? tax : null,
			comment: comment != null && comment !== '' ? comment : null
		};
		console.log('Adding portfolio detail', detail);

		await fetch('https://ostium.ch/api/borsalino/add_portfolio_detail.php', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
				'Authorization': 'JWT ' + encodeURIComponent(token)
			},
			body: JSON.stringify(detail)
		}).then(result => {
			if (result.ok) {
				console.log('Saved asset detail successfully.');
				jQuery('#buySellDialog').modal('hide');
				result.json().then(data => {
					console.log('Asset detail:', data);
					dispatch('message', {
						type: 'success',
						text: data.message.replace(/\(.*\)/g, isin)
					});
					dispatch('update', {
						type: 'portfolio',
						text: data.message
					});
				});
			} else {
				console.warn('Could not add portfolio detail of ISIN ' + isin, result.statusText);
				result.text().then(data => {
					console.log('Error:', data);
					dispatch('message', {
						type: 'error',
						text: data.replace(/<.*>/g, '')
					});
				});
			}
		});
	}

	function closeModal(event) {
		isin = null;
		stock = {};
		title = '';
		date = null;
		quantity = null;
		price = null;
		fee = null;
		tax = null;
		comment = null;
		return event;
	}

	onMount(() => {
		jQuery('#buySellDialog').on('show.bs.modal', function (event) {
			let target =  event.relatedTarget;
			if (target != null && target.dataset != null && target.dataset['isin'] != null) {
				isin = target.dataset['isin'];
				loadAssetDetail();
			}
		});
		jQuery('#savePortfolioDetail').popover({
			container: 'body',
			placement: 'top'
		});
	});
</script>

<div class="modal fade" id="buySellDialog" data-backdrop="static" tabindex="-1" role="dialog">
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content bg-dark">
			<div class="modal-header">
				<h5 class="modal-title">Buy/Sell {title}</h5>
				<button type="button" class="close text-light" on:click={closeModal} data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body bg-dark text-light">
				<form>
					<fieldset class="form-group">
						<div class="row">
							<legend class="col-form-label col-sm-2 pt-0"></legend>
							<div class="col-sm-10">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" bind:group={buySell} id="buy" value="buy">
									<label class="form-check-label mr-3" for="buy">Buy</label>
									<input class="form-check-input" type="radio" bind:group={buySell} id="sell" value="sell">
									<label class="form-check-label mr-3" for="sell">Sell</label>
									<input class="form-check-input" type="radio" bind:group={buySell} id="dividend" value="dividend">
									<label class="form-check-label" for="dividend">Dividend</label>
								</div>
							</div>
						</div>
					</fieldset>
					<div class="form-group row">
						<label for="date" class="col-sm-2 col-form-label">Date</label>
						<div class="col-sm-10">
							<input type="date" class="form-control bg-secondary text-light" id="date" bind:value={date} required>
						</div>
					</div>
					<div class="form-group row">
						<label for="quantity" class="col-sm-2 col-form-label">Quantity</label>
						<div class="col-sm-10">
							<input type="number" class="form-control bg-secondary text-light" id="quantity" bind:value={quantity}>
						</div>
					</div>
					<div class="form-group row">
						<label for="price" class="col-sm-2 col-form-label">Price</label>
						<div class="col-sm-10">
							<input type="number" step="0.01" class="form-control bg-secondary text-light" id="price" bind:value={price}>
						</div>
					</div>
					<div class="form-group row">
						<label for="fee" class="col-sm-2 col-form-label">Fee</label>
						<div class="col-sm-10">
							<input type="number" step="0.01" class="form-control bg-secondary text-light" id="fee" bind:value={fee}>
						</div>
					</div>
					<div class="form-group row">
						<label for="tax" class="col-sm-2 col-form-label">Tax</label>
						<div class="col-sm-10">
							<input type="number" step="0.01" class="form-control bg-secondary text-light" id="tax" bind:value={tax}>
						</div>
					</div>
					<div class="form-group row">
						<div class="col-sm-2">Total</div>
						<div class="col-sm-10">
							{(quantity != null && price != null) ? formatCurrency((buySell === 'buy' ? quantity : -quantity) * price + (fee != null ? fee : 0) + (tax != null ? tax : 0), stock.currency) : ''}
						</div>
					</div>
					<div class="form-group row">
						<label for="comment" class="col-sm-2 col-form-label">Comment</label>
						<div class="col-sm-10">
							<textarea class="form-control bg-secondary text-light" id="comment" bind:value={comment} rows="3"></textarea>
						</div>
					</div>
				</form>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" on:click={closeModal} data-dismiss="modal">Close</button>
				{#if user != null && user.role_id !== ROLE_VIEWER}
				<button type="button" class="btn btn-primary" on:click={savePortfolioDetail}>Save changes</button>
				{:else}
				<button type="button" class="btn btn-primary disabled" id="savePortfolioDetail" data-toggle="popover" data-content="Saving is not available to viewers.">Save changes</button>
				{/if}
			</div>
		</div>
	</div>
</div>
